<script>
  import PageBody from "$lib/components/Page/PageBody.svelte";
  export let page;
</script>

<div
  class="w-full px-24 md:px-175 lg:max-w-1014 lg:px-0 m-auto flex flex-col justify-center items-center"
>
  <div class="w-full">
    <!-- no additional padding, etc added to this class because it's all just one RichText, which will add padding as expected -->
    <PageBody body={page.fields.body} class="last-page-element" />
  </div>
</div>
